import React, { Component } from "react";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";
import Footer from "../Common/Footer";
import logo from "../Images/logo.jpg";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      username_error_msg: "",
      password_error_msg: "",
      invalidForm: false
    };
  }

  changeValue(e, type) {
    const value = e.target.value;

    let invalid = true;
    if (type === "username") {
      this.setState({ username: value });
      if (value === "") {
        this.setState({ username_error_msg: "Enter Usrename" });
      } else {
        this.setState({ username_error_msg: "" });
        if (this.state.password === "") invalid = true;
        else invalid = false;
      }
    } else {
      this.setState({ password: value });

      if (value === "") {
        this.setState({ password_error_msg: "Enter Password" });
      } else {
        this.setState({ password_error_msg: "" });
        if (this.state.username === "") invalid = true;
        else invalid = false;
      }
    }

    this.setState({ invalidForm: invalid });
  }

  render() {
    const { onClick } = this.props;

    return (
      <>
        <div className="container-fluid">
          <div className="row">
            <div className="col col-md-9">
              <div id="blank100" />
              <div className="row">
                <div className="col-12">
                  <img src={logo} />
                </div>
              </div>
            </div>
            <div className="col col-md-3 ">
              <MuiThemeProvider>
                <div className="loginBg border" style={this.getHeight()}>
                  <div style={this.getInnerHeight()} />
                  <div className="bannerLogin">{this.props.title}</div>
                  <div>
                    <TextField
                      hintText="Enter your Username"
                      floatingLabelText="Username"
                      errorText={this.state.username_error_msg}
                      onChange={e => this.changeValue(e, "username")}
                    />
                    <br />
                    <TextField
                      type="password"
                      hintText="Enter your Password"
                      floatingLabelText="Password"
                      errorText={this.state.password_error_msg}
                      onChange={e => this.changeValue(e, "password")}
                    />
                    <br />
                    <RaisedButton
                      label="Login"
                      primary={true}
                      style={style}
                      disabled={this.state.invalidForm}
                      onClick={() =>
                        this.props.onClick(
                          this.state.username,
                          this.state.password
                        )
                      }
                    />
                  </div>
                </div>
              </MuiThemeProvider>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  getHeight() {
    var hgt = window.innerHeight - 42;
    return { height: hgt + "px" };
  }

  getInnerHeight() {
    var hgt = window.innerHeight / 2 - 150;
    return { height: hgt + "px" };
  }
}
const style = {
  margin: 15
};

export default Login;
